import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import useTheme from 'api/useTheme';

import { IStoreSettingsFormValues } from '../StoreSettings.types';
import { buildStoreSettingsInitialValues } from '../StoreSettings.utils';

type UseThemeReturn = ReturnType<typeof useTheme>;

interface IUseStoreSettingsInitialValuesReturn {
  initialValues: IStoreSettingsFormValues;
  getGeneralTheme: UseThemeReturn['getGeneralTheme'];
}

/**
 * Derives the Store Settings form initial values from the persisted general
 * theme, falling back to defaults for any missing quantity-format field, and
 * exposes the underlying query for loading/error handling.
 *
 * @example
 * const { initialValues, getGeneralTheme } = useStoreSettingsInitialValues();
 */
export const useStoreSettingsInitialValues =
  (): IUseStoreSettingsInitialValuesReturn => {
    const { publisherId } = useParams();
    const { getGeneralTheme } = useTheme(publisherId);

    const initialValues = useMemo(
      () => buildStoreSettingsInitialValues(getGeneralTheme.data),
      [getGeneralTheme.data]
    );

    return { initialValues, getGeneralTheme };
  };
